import { render } from "./TweetForm.vue?vue&type=template&id=76cf17ff"
import script from "./TweetForm.vue?vue&type=script&lang=js"
export * from "./TweetForm.vue?vue&type=script&lang=js"

import "./TweetForm.vue?vue&type=style&index=0&id=76cf17ff&lang=scss"

import exportComponent from "C:\\Users\\guada\\OneDrive\\Documents\\GitHub\\simulador-tweets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__